import { LoadingButton as Button } from '../mfaWizard/LoadingButton/LoadingButton'
import { PropTypes } from 'prop-types'
import RecommendedIcon from  '../../globals/images/icon-recommended.svg' 
    
export const NoFactors = ( { webId, onSetUp }  ) => {

    const setUpText = ' Set up '
    const twoFAText = 'two-step verification'
    const descriptionText = ' for your account and you\'ll receive a 6-digit code via email or text to use when signing in'
    const allText = `${ setUpText }${ twoFAText }${ descriptionText }`

return <>
    <div className='c-form-container c-form-container--box mb-5 adsec-container'>
        <div className='adsec-recommend'> 
            <img src={ RecommendedIcon } alt="Recommended" className="svg-recommended"/>
            Recommended 
        </div>
        <div className='adsec-setup'>
            <div tabIndex='0' className='adsec-text' aria-label={ allText }><span>{setUpText}</span><strong>{twoFAText}</strong><span>{descriptionText}</span> </div>
            <div className='adsec-btn'>  
                <Button id='dt-mfa-setup' tabIndex={ 0 } className={ 'mfa-app-link c-btn c-btn--tertiary mb-5 bx--btn bx--btn--primary' } aria-label= 'Set up two-step verification enabled' name="goBack" type='button' data-testid="btn-setUp" onClick={ () => onSetUp() }>Set Up</Button>

            </div>
        </div> 
    </div>
</>
}

NoFactors.propTypes = {
    webId: PropTypes.string,
    onSetUp: PropTypes.func 
}